module.exports = __webpack_public_path__ + "static/img/no_subscription.a97e5dbf.svg";